import React, { useState } from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, InputAdornment, Pagination } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { grey } from '@mui/material/colors';

// Fake data - replace with actual data fetching
const fakeTaskAssignmentRules = [
  { id: 1, name: 'New Booking', priority: 1, sourceName: 'SVP, Sales & Marketing', destinationName: 'Automated Process' },
  { id: 2, name: 'M FTAR', priority: 1, sourceName: 'Director, Direct Sales', destinationName: 'Automated Process' },
];

function Tasks() {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const rowsPerPage = 8;

  // Filter and paginate
  const filteredRules = fakeTaskAssignmentRules.filter((rule) => {
    if (!searchTerm) return true;
    const searchLower = searchTerm.toLowerCase();
    return (
      rule.name?.toLowerCase().includes(searchLower) ||
      rule.sourceName?.toLowerCase().includes(searchLower) ||
      rule.destinationName?.toLowerCase().includes(searchLower)
    );
  });

  const pageCount = Math.ceil(filteredRules.length / rowsPerPage);
  const paginatedRules = filteredRules.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

  return (
    <Card>
      <ArgonBox p={3}>
        <ArgonTypography variant="h6" textAlign="left" mb={2}>
          Fulfillment Task Assignment Rules
        </ArgonTypography>
        
        {/* Search Bar */}
        <ArgonBox mb={2} display="flex" justifyContent="flex-end">
          <TextField
            size="medium"
            placeholder="Search task assignment rules..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPage(0); // Reset to first page on search
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ maxWidth: '250px' }}
          />
        </ArgonBox>

        {/* Table */}
        {paginatedRules.length > 0 ? (
          <>
            <TableContainer component={Paper}>
              <Table aria-label="fulfillment task assignment rules table">
                <TableHead sx={{ display: 'contents' }}>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Name</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Priority</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Source Name</TableCell>
                    <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Destination Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedRules.map((option) => (
                    <TableRow key={option.id}>
                      <TableCell>{option.name}</TableCell>
                      <TableCell>{option.priority}</TableCell>
                      <TableCell>{option.sourceName}</TableCell>
                      <TableCell>{option.destinationName}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            {pageCount > 1 && (
              <ArgonBox display="flex" justifyContent="center" mt={3}>
                <Pagination
                  count={pageCount}
                  page={page + 1}
                  onChange={(e, newPage) => setPage(newPage - 1)}
                  color="primary"
                />
              </ArgonBox>
            )}
          </>
        ) : (
          <ArgonBox p={3} textAlign="center">
            <ArgonTypography variant="body2" color="textSecondary">
              {searchTerm ? 'No task assignment rules match your search.' : 'No task assignment rules found.'}
            </ArgonTypography>
          </ArgonBox>
        )}
      </ArgonBox>
    </Card>
  );
}

export default Tasks;